import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  serviceProvider: {}
};

const serviceProvider = createSlice({
  name: 'serviceProvider',
  initialState,
  reducers: {
    init(state, action) {
      const { serviceProvider } = action.payload;
      state.serviceProvider = serviceProvider;
    }
  }
});

export const {
  init
} = serviceProvider.actions;

export default serviceProvider.reducer;